import { selectRootSliceFCCJ } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

export const selectThisSlice = state => {
  const appSlice = selectRootSliceFCCJ(state);
  return appSlice[ROOT_SLICE] || state;
};

export const selectData = stateAdmin => {
	const slice = selectThisSlice(stateAdmin);
	const { data } = slice;
	return data;
};

export const selectDataByCustomer = (stateAdmin, { customer }) => {
	const data = selectData(stateAdmin);
	return data[customer] || EMPTY_ARRAY;
};

export const selectBoolMap = stateAdmin => {
	const slice = selectThisSlice(stateAdmin);
	const { boolMap } = slice;
	return boolMap;
};

export const selectBoolMapByCustomer = (stateAdmin, { customer } = {}) => {
	const slice = selectThisSlice(stateAdmin);
	const { boolMap } = slice;
	return boolMap[customer] || EMPTY_OBJECT;
};

export const selectIsLoadingIsLoaded = state => {
  const slice = selectThisSlice(state);
  const { isLoading, isLoaded } = slice;
  return { isLoading, isLoaded };
}

export const selectIsLoading = stateAdmin => {
	const slice = selectThisSlice(stateAdmin);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = stateAdmin => {
	const slice = selectThisSlice(stateAdmin);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = stateAdmin => {
	const slice = selectThisSlice(stateAdmin);
	const { errorMessage } = slice;
	return errorMessage;
};

export default {
	selectData,
	selectDataByCustomer,
	selectBoolMap,
	selectBoolMapByCustomer,
  selectIsLoadingIsLoaded,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage
};
